// extracted by mini-css-extract-plugin
export default {"container":"forgotPasswordForm_container__GROYP"};